import type { Data } from "@eai-toolkit/client";
import { useMemo } from "react";

import { useGetAllDataObjectsQuery } from "../api/dataApi";

/**
 * Hook that fetches data objects and returns both the list and a Map for lookups.
 */
export function useDataObjectsWithMap() {
  const queryResult = useGetAllDataObjectsQuery();

  const dataObjectsList = useMemo(
    () => queryResult.data ?? [],
    [queryResult.data],
  );

  const dataObjectsMap = useMemo(() => {
    const map = new Map<string, Data>();
    dataObjectsList.forEach((dataObject) => {
      map.set(dataObject.id, dataObject);
      if (dataObject.fullName) {
        map.set(dataObject.fullName, dataObject);
      }
    });
    return map;
  }, [dataObjectsList]);

  return {
    ...queryResult,
    dataObjectsList,
    dataObjectsMap,
  };
}
